import { BuildingInfo } from './MapIframe';

export class CalculatorUtil {

    public static getSegmentsCount(buildingInfo: BuildingInfo | null) {
        return buildingInfo?.roofSegments
            .filter((it) => it.inCart)
            .length || 0;
    }

    public static formatNumber(number?: number, fractionDigits: number = 2): string {
        return number?.toLocaleString('et', {
            'minimumFractionDigits': fractionDigits || 0,
            'maximumFractionDigits': fractionDigits || 0,
        }) || '';
    }


}